import { Injectable } from '@angular/core';
import { Route, RouteTitlesProviderService } from '@web/common';

@Injectable()
export class AppRouteTitlesProviderService extends RouteTitlesProviderService {
  public override titles(): Map<Route, string> {
    return new Map([
      [Route.BoxCreate, 'Dodaj box kosmetyczny'],
      [Route.BoxQuestionnaireDetails, 'Podgląd ankiety'],
      [Route.BoxQuestionnaires, 'Ankiety'],
      [
        Route.BoxSaleDetails,
        'Podgląd konfiguracji sprzedaży boxa kosmetycznego',
      ],
      [
        Route.BoxSaleDetailsFromBoxes,
        'Podgląd konfiguracji sprzedaży boxa kosmetycznego',
      ],
      [Route.BoxSaleEdit, 'Konfiguracja sprzedaży boxa kosmetycznego'],
      [Route.BoxSales, 'Boxy kosmetyczne - sprzedaż'],
      [Route.BoxSaleBoxDetails, 'Podgląd boxa kosmetycznego'],
      [Route.BoxDetails, 'Szczegóły boxa kosmetycznego'],
      [Route.BoxEdit, 'Edycja boxa kosmetycznego'],
      [Route.Boxes, 'Boxy kosmetyczne'],
      [Route.BrandCreate, 'Dodaj markę'],
      [Route.BrandDetails, 'Podgląd marki'],
      [Route.BrandEdit, 'Edycja marki'],
      [Route.Brands, 'Marki kosmetyczne'],
      [Route.Companies, 'Firmy'],
      [Route.CompanyCreate, 'Dodaj firmę'],
      [Route.CompanyDetails, 'Szczegóły firmy'],
      [Route.CompanyEdit, 'Edycja firmy'],
      [Route.PageCreate, 'Tworzenie strony'],
      [Route.PageDetails, 'Podgląd strony'],
      [Route.PageEdit, 'Edycja strony'],
      [Route.Pages, 'Lista stron'],
      [Route.FaqCategories, 'Lista kategorii FAQ'],
      [Route.FaqCategoryDetails, 'Podgląd kategorii FAQ'],
      [Route.FaqCategoryCreate, 'Tworzenie kategorii FAQ'],
      [Route.FaqCategoryEdit, 'Edycja kategorii FAQ'],
      [Route.CosmeticCreate, 'Dodaj kosmetyk'],
      [Route.CosmeticDetails, 'Szczegóły kosmetyku'],
      [Route.CosmeticEdit, 'Edytuj kosmetyk'],
      [Route.Cosmetics, 'Kosmetyki'],
      [Route.Dashboard, 'Dashboard'],
      [Route.DictionaryBoxCategoryCreate, 'Dodawanie kategorii'],
      [Route.DictionaryBoxCategoryEdit, 'Edycja kategorii'],
      [Route.DictionaryBoxCategoryList, 'Kategorie boxów'],
      [Route.DictionaryCountryCreate, 'Dodawanie kraju'],
      [Route.DictionaryCountryEdit, 'Edycja kraju'],
      [Route.DictionaryCountryList, 'Kraje'],
      [Route.DictionaryList, 'Słowniki'],
      [Route.DictionaryProductAttributeCreate, 'Dodawanie atrybutu produktu'],
      [Route.DictionaryProductAttributeEdit, 'Edycja atrybutu produktu'],
      [Route.DictionaryProductAttributeList, 'Kategorie atrybutu produktu'],
      [Route.Invoices, 'Lista faktur'],
      [Route.Loading, 'Ładowanie'],
      [Route.Multimedia, 'Biblioteka mediów'],
      [Route.MultimediaGridView, 'Widok siatki'],
      [Route.MultimediaListView, 'Widok listy'],
      [Route.MultimediaUpload, 'Przesyłanie plików'],
      [Route.OrderDetails, 'Szczegóły zamówienia'],
      [Route.OrderPartialRefund, 'Częściowy zwrot zamówienia'],
      [Route.Orders, 'Zamówienia'],
      [Route.PaymentMethodDetails, 'Szczegóły metody płatności'],
      [Route.PaymentMethodEdit, 'Edycja metody płatności'],
      [Route.PaymentMethods, 'Metody płatności'],
      [Route.ProductCreate, 'Dodaj produkt'],
      [Route.ProductDetails, 'Szczegóły produktu'],
      [Route.ProductEdit, 'Edytuj produkt'],
      [Route.Products, 'Produkty'],
      [Route.ShippingMethodDetails, 'Szczegóły metody wysyłki'],
      [Route.ShippingMethodEdit, 'Edycja metody wysyłki'],
      [Route.ShippingMethods, 'Metody wysyłki'],
      [Route.ShopConfig, 'Konfiguracja sklepu'],
      [Route.ShopKsefConfiguration, 'Konfiguracja faktur'],
      [Route.ShopRefundSettings, 'Konfiguracja zwrotów'],
      [Route.ShopShippingSettings, 'Konfiguracja wysyłki'],
      [Route.ShopValidationSettings, 'Konfiguracja walidacji'],
      [Route.ShopCartSettings, 'Konfiguracja koszyka'],
      [Route.BackgroundTasks, 'Zadania w tle'],
      [Route.ShopHomeBannerCreate, 'Dodawanie baneru strony głównej'],
      [Route.ShopHomeBannerDetails, 'Szczegóły baneru strony głównej'],
      [Route.ShopHomeBannerEdit, 'Edycja baneru strony głównej'],
      [Route.ShopHomeBannerList, 'Slider strony głównej'],
      [Route.ShopBannerCreate, 'Dodawanie baneru'],
      [Route.ShopBannerDetails, 'Szczegóły baneru'],
      [Route.ShopBannerEdit, 'Edycja baneru'],
      [Route.ShopBannerList, 'Banery'],
      [Route.ShopSubscribeBannerCreate, 'Dodawanie baneru subskrypcji'],
      [Route.ShopSubscribeBannerDetails, 'Szczegóły baneru subskrypcji'],
      [Route.ShopSubscribeBannerEdit, 'Edycja baneru subskrypcji'],
      [Route.ShopSubscribeBannerList, 'Slider subskrypcji'],
      [Route.SignOut, 'Wyloguj'],
      [Route.SubscriptionBulkPriceChange, 'Grupowa zmiana ceny subskrypcji'],
      [Route.SubscriptionDetails, 'Szczegóły subskrypcji'],
      [Route.Subscriptions, 'Lista subskrybentów'],
      [Route.UserCreate, 'Dodaj użytkownika'],
      [Route.UserDetails, 'Szczegóły użytkownika'],
      [Route.UserEdit, 'Edycja użytkownika'],
      [Route.Users, 'Użytkownicy'],
      [Route.Notifications, 'Lista powiadomień'],
      [Route.NotificationDetails, 'Podgląd powiadomienia'],
      [Route.Warehouse, 'Magazyn'],
      [Route.WarehouseLocalizationCreate, 'Dodawanie lokalizacji'],
      [Route.WarehouseLocalizationEdit, 'Edycja lokalizacji'],
      [Route.WarehouseLocalizations, 'Lokalizacje w magazynie'],
      [Route.WarehouseOwners, 'Właściciele magazynu'],
      [Route.WarehouseProductDetails, 'Szczegóły produktu'],
      [Route.WarehouseProductEdit, 'Edycja produktu'],
      [Route.WarehouseProducts, 'Produkty'],
      [Route.WarehouseReceiptCreate, 'Dodawanie przyjęcia zewnętrznego'],
      [Route.WarehouseReceiptDetails, 'Szczegóły przyjęcia zewnętrznego'],
      [Route.WarehouseReceiptEdit, 'Edycja przyjęcia zewnętrznego'],
      [Route.WarehouseReceipts, 'Przyjęcia zewnętrzne'],
      [Route.WarehouseReleaseCreate, 'Dodawanie wydania zewnętrznego'],
      [Route.WarehouseReleaseDetails, 'Szczegóły wydania zewnętrznego'],
      [Route.WarehouseReleaseEdit, 'Edycja wydania zewnętrznego'],
      [Route.WarehouseReleases, 'Wydanie zewnętrzne'],
      [Route.WarehouseRestockCreate, 'Dodawanie zwrotu'],
      [Route.WarehouseRestockDetails, 'Szczegóły zwrotu'],
      [Route.WarehouseRestockEdit, 'Edycja zwrotu'],
      [Route.WarehouseRestocks, 'Zwroty'],
    ]);
  }
}
